interface ListNoResultsProps {
  gameNo?: number;
  id?: string;
}

function ListNoResults({ gameNo = 5, id = 'some key' }: ListNoResultsProps) {
  return (
    <div className='flex h-[63.5px] items-center sm:h-[72.5px]'>
      {Array.from({ length: gameNo }).map((_, i) => (
        <div
          key={`${id}-${i}`}
          className={`flex h-full w-10 animate-pulse items-center justify-center ${i % 2 === 0 ? 'bg-[#f9f9f9]' : 'bg-white'} p-3`}
        >
          -
        </div>
      ))}
    </div>
  );
}

export default ListNoResults;
